var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFillSystemsArrowGoForwardFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2599_108650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 9.33337H14.6667C12.5449 9.33337 10.5101 10.1762 9.00981 11.6765C7.50952 13.1768 6.66667 15.2116 6.66667 17.3334C6.66667 19.4551 7.50952 21.4899 9.00981 22.9902C10.5101 24.4905 12.5449 25.3334 14.6667 25.3334H26.6667V28H14.6667C11.8377 28 9.12458 26.8762 7.12419 24.8758C5.12381 22.8755 4 20.1623 4 17.3334C4 14.5044 5.12381 11.7913 7.12419 9.7909C9.12458 7.79051 11.8377 6.66671 14.6667 6.66671H21.3333V1.33337L29.3333 8.00004L21.3333 14.6667V9.33337Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2599_108650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillSystemsArrowGoForwardFill);
export default __webpack_public_path__ + "static/media/Fill__Systems--arrow-go-forward-fill.27bcd9c89f9bfc771167d68c079c6049.svg";
export { ForwardRef as ReactComponent };